import { render, staticRenderFns } from "./tableTypeConfig.vue?vue&type=template&id=0d4a38ac&"
import script from "./tableTypeConfig.vue.ts?vue&type=script&lang=ts&"
export * from "./tableTypeConfig.vue.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports